import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6122a4c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "titleContainer"
}
const _hoisted_2 = {
  key: 1,
  class: "buttonsContainer"
}
const _hoisted_3 = { class: "photoRequestedMessage mb-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = {
  key: 1,
  class: "text-center"
}
const _hoisted_7 = { class: "mb-2 small" }
const _hoisted_8 = {
  key: 2,
  class: "text-center"
}
const _hoisted_9 = { class: "small text-muted" }
const _hoisted_10 = { class: "small text-muted" }
const _hoisted_11 = { class: "closer" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_description_binder = _resolveComponent("description-binder")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createElementBlock("div", {
    class: "opModal",
    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close'))),
    onTouchmove: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent","stop"]))
  }, [
    _createElementVNode("div", {
      class: "pinchTextContainer",
      ref: "pinchTextContainer",
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showText = !_ctx.showText), ["stop"]))
    }, [
      (_ctx.item.title && _ctx.item.title.values && _ctx.item.title.values[_ctx.$store.state.selectedLanguage] || 
                _ctx.item.description && _ctx.item.description.values && _ctx.item.description.values[_ctx.$store.state.selectedLanguage])
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["textContainer", { show: _ctx.showText }]),
            ref: "textContainer"
          }, [
            (_ctx.item.title && _ctx.item.title.values && _ctx.item.title.values[_ctx.$store.state.selectedLanguage])
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.item.title.values[_ctx.$store.state.selectedLanguage]), 1))
              : _createCommentVNode("", true),
            (_ctx.item.description && _ctx.item.description.values && _ctx.item.description.values[_ctx.$store.state.selectedLanguage])
              ? (_openBlock(), _createBlock(_component_description_binder, {
                  key: 1,
                  class: "descriptionContainer",
                  "html-text": _ctx.item.description.values[_ctx.$store.state.selectedLanguage]
                }, null, 8, ["html-text"]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.alreadyBought)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Foto acquistata",
                        text: "Foto acquistata"
                      }),
                      _createTextVNode("  ✓ ")
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-success",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args)), ["stop"]))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Scarica originale",
                        text: "Scarica originale"
                      })
                    ])
                  ]))
                : (_ctx.creditBalance > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Crediti disponibili",
                          text: "Crediti disponibili"
                        }),
                        _createTextVNode(":  " + _toDisplayString(_ctx.creditBalance), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-primary",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.purchase && _ctx.purchase(...args)), ["stop"]))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Acquista con 1 credito",
                          text: "Acquista con 1 credito"
                        })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Crediti foto insufficienti",
                          text: "Crediti foto insufficienti"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_router_link, {
                          to: "/village/shop",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Vai nello shop per ricaricare",
                              text: "Vai nello shop per ricaricare"
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "btn btn-link",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_icon_close)
      ])
    ]),
    _createElementVNode("img", {
      src: _ctx.item.attachment.publicUrl,
      ref: "pinch",
      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.showText = !_ctx.showText), ["stop"]))
    }, null, 8, _hoisted_12)
  ], 32))
}